import { Skeleton } from "antd";

const HeaderSkeleton = () => (
    <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex min-w-0 flex-1 items-start gap-3">
            <Skeleton.Button active shape="square" className="!h-9 !w-9 !min-w-[36px] !rounded-lg" />
            <div className="min-w-0 flex-1">
                <Skeleton active title={{ width: "55%" }} paragraph={{ rows: 1, width: "40%" }} />
            </div>
        </div>
        <Skeleton.Button active className="!h-10 !w-[108px] !rounded-lg" />
    </div>
);

export default HeaderSkeleton;
